import { ReactComponent as TrashIcon } from "../../assets/icons/tables/trash-icon.svg";
import { ReactComponent as EditIcon } from "../../assets/icons/tables/edit-icon.svg";
import { useState } from "react";
import { DeleteModal } from "..";
import dayjs from "dayjs";
import relativeTime from "dayjs/plugin/relativeTime";
import { Tooltip } from "@material-tailwind/react";
import { useNavigate } from "react-router";
import { useQualityInput } from "../../store/useQualityInput";

dayjs.extend(relativeTime);

export const QualityInputTable = () => {
  /** Hooks */
  const { allQualityInputs, deleteQualityInput } = useQualityInput();
  const navigate = useNavigate();
  /** State */
  const [isOpen, setIsOpen] = useState(false);

  const toggleModal = () => setIsOpen(!isOpen);

  return (
    <div className="relative overflow-x-auto">
      <table className="w-full text-base font-normal font-satoshi text-left rtl:text-right text-dark">
        <thead className="font-medium bg-gray-50">
          <tr>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              ID
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4">
              Date
            </th>
            <th
              scope="col"
              className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
            >
              Weight
            </th>
            <th scope="col" className="px-2 sm:px-6 py-1 sm:py-4 text-right">
              Actions
            </th>
          </tr>
        </thead>
        <tbody>
          {allQualityInputs?.map((item) => {
            return (
              <tr
                key={item._id}
                className="bg-white hover:bg-gray-100 cursor-pointer transition ease-linear border-b"
              >
                <td
                  onClick={() => navigate(`/edit-quality-input/${item?._id}`)}
                  className="px-2 sm:px-6 py-1 sm:py-4 break-all"
                >
                  {item?._id}
                </td>
                <td
                  onClick={() => navigate(`/edit-quality-input/${item?._id}`)}
                  className="px-2 sm:px-6 py-1 sm:py-4"
                >
                  {dayjs(item?.dropDate).format("DD/MM/YYYY")}
                </td>
                <td
                  onClick={() => navigate(`/edit-quality-input/${item?._id}`)}
                  className="hidden sm:table-cell px-2 sm:px-6 py-1 sm:py-4"
                >
                  {item?.totalWeight}
                </td>
                <td className="px-2 sm:px-6 py-1 sm:py-4 flex items-center justify-end cursor-pointer">
                  <Tooltip content="Edit">
                    <EditIcon
                      onClick={() =>
                        navigate(`/edit-quality-input/${item?._id}`)
                      }
                      className="mr-3 sm:mr-7"
                    />
                  </Tooltip>
                  <Tooltip content="Delete">
                    <TrashIcon
                      onClick={() => {
                        const confirmDelete = window.confirm(
                          "Are you sure you want to delete this Quality Input?"
                        );
                        if (confirmDelete) {
                          deleteQualityInput(item._id as string);
                        }
                      }}
                    />
                  </Tooltip>
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <DeleteModal isOpen={isOpen} closeModal={toggleModal} />
    </div>
  );
};
